import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import FAQCard from "../../components/Common/FAQCard";
import NodataAvailable from "../../components/Common/NodataAvailable";
import ContentLoader from "../ContentLoader";
const Faq = () => {
  const [faq, setFaq] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`/api/faq`).then((res) => {
      setLoading(false);
      if (res.status === 200) {
        setFaq(res.data.data);
      }
    });
  }, []);

  return (
    <>
      {loading ? (
        <ContentLoader />
      ) : (
        <>
          {faq.length === 0 ? (
            <NodataAvailable />
          ) : (
            <FAQCard title={"FAQ"} description={faq} />
          )}
        </>
      )}
    </>
  );
};

export default Faq;
